import {animateByClass} from '../../Library/Animation';

export const shakeUnsaved = (element) => {
    if (element.classList.contains('shake')) {
        return;
    }

    animateByClass(element, 'shake');
    element.dispatchEvent(new CustomEvent('unsaved:shake', {bubbles: true}));
};
